import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default (Alpine) => {
  Alpine.data('trendingProductsSlider', () => ({
    swiper: null,
    mediaQuery: null,
    changeHandler: null,

    init() {
      this.mediaQuery = window.matchMedia('(min-width: 1110px)');
      this.changeHandler = () => this._update();
      this.mediaQuery.addEventListener('change', this.changeHandler);
      this._update();
    },

    destroy() {
      this.mediaQuery?.removeEventListener('change', this.changeHandler);
      this._destroySwiper();
    },

    _update() {
      if (this.mediaQuery.matches) {
        this._destroySwiper();
      } else {
        this._initSwiper();
      }
    },

    _initSwiper() {
      if (this.swiper) return;

      this.swiper = new Swiper(this.$refs.slider, {
        modules: [Navigation, Pagination],
        slidesPerView: 2.15,
        spaceBetween: 4,
        observer: true,
        observeParents: true,
        navigation: {
          prevEl: this.$refs.prev,
          nextEl: this.$refs.next,
        },
        pagination: {
          el: this.$refs.pagination,
          clickable: true,
        },
      });
    },

    _destroySwiper() {
      if (!this.swiper) return;

      this.swiper.destroy(true, true);
      this.swiper = null;
    },
  }));
};
